export default "__VITE_ASSET__3bbe3b29__"